module.exports = __webpack_public_path__ + "b8a04b3e023a5dcb4ebd8a28ca91c411.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/strategie/gestion_de_communaute.jpg
// module id = 146
// module chunks = 0